import axios from 'axios'
import { supabase } from './supabase'

export const api = axios.create()

api.interceptors.request.use(async (config) => {
  try {
    // Get current session
    let { data: { session } } = await supabase.auth.getSession()

    // If session exists but might be expired, try to refresh it
    if (session) {
      const expiresAt = session.expires_at
      const now = Math.floor(Date.now() / 1000)

      // If token expires in less than 60 seconds, refresh it
      if (expiresAt && expiresAt - now < 60) {
        const { data: { session: refreshedSession } } = await supabase.auth.refreshSession()
        if (refreshedSession) {
          session = refreshedSession
        }
      }

      if (session?.access_token) {
        config.headers = config.headers || {}
        ;(config.headers as any).Authorization = `Bearer ${session.access_token}`
      }
    }
  } catch (err) {
    console.error('Failed to get session:', err)
  }
  return config
})

/**
 * Env�a la se�al de reconocimiento de alerta al backend de Express
 * @param mangoId ID de la alerta de Mango OS
 */
export const acknowledgeAlert = async (mangoId: number) => {
  try {
    // Usamos la instancia 'api' para aprovechar el interceptor de tokens
    const response = await api.post('/api/alerts/acknowledge', { 
      mango_id: mangoId 
    });
    
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(error.response?.data?.error || 'Error al reconocer la alerta');
    }
    throw error;
  }
};

/**
 * Obtiene las alertas activas desde el backend
 */
export const getActiveAlerts = async () => {
  try {
    const response = await api.get('/api/alerts/active');
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(error.response?.data?.error || 'Error al obtener alertas');
    }
    throw error;
  }
};
